import { render } from "./VIPManage.vue?vue&type=template&id=e96f86da&scoped=true"
import script from "./VIPManage.vue?vue&type=script&lang=js"
export * from "./VIPManage.vue?vue&type=script&lang=js"

import "./VIPManage.vue?vue&type=style&index=0&id=e96f86da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e96f86da"]])

export default __exports__